import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    inputStartAdornment: {
      paddingLeft: theme.spacing(2),
    },
    inputEndAdornment: {
      paddingRight: theme.spacing(1),
    },
    iconAiPen: {
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(16),
    },
    iconSend: {
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(16),
    },
  }),
  { name: 'InstructionsInput' }
);
